export const MONTH_NAMES = [
  "Tháng 1",
  "Tháng 2",
  "Tháng 3",
  "Tháng 4",
  "Tháng 5",
  "Tháng 6",
  "Tháng 7",
  "Tháng 8",
  "Tháng 9",
  "Tháng 10",
  "Tháng 11",
  "Tháng 12",
];

export const WEEK_DAYS = ["T2", "T3", "T4", "T5", "T6", "T7", "CN"];

export function parseInputDate(val?: string): { date: Date; hasTime: boolean } | null {
  if (!val) return null;
  // Format: YYYY-MM-DD (local date)
  if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
    const [y, m, d] = val.split("-").map(Number);
    if (!y || !m || !d) return null;
    return { date: new Date(y, m - 1, d), hasTime: false };
  }
  // Format: DD/MM/YYYY or DD/MM/YYYY HH:mm
  if (val.includes("/")) {
    const parts = val.split(" ");
    const datePart = parts[0];
    if (!datePart) return null;
    const [d, m, y] = datePart.split("/").map(Number);
    if (!d || !m || !y) return null;
    const date = new Date(y, m - 1, d);
    if (parts[1]) {
      const [hh, mm] = parts[1].split(":").map(Number);
      date.setHours(hh || 0, mm || 0, 0, 0);
      return { date, hasTime: true };
    }
    return { date, hasTime: false };
  }

  const date = new Date(val);
  if (isNaN(date.getTime())) return null;
  const hasTime = val.includes("T") || val.includes(":");
  return { date, hasTime };
}

export function formatDateDisplay(d: Date, withTime: boolean): string {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  if (withTime) {
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  return `${day}/${month}/${year}`;
}

export function toIsoDate(d: Date): string {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
}

export function isDayOutOfRange(date: Date, minDate?: string, maxDate?: string): boolean {
  const day = toIsoDate(date);
  if (minDate && day < minDate.slice(0, 10)) return true;
  if (maxDate && day > maxDate.slice(0, 10)) return true;
  return false;
}

export function formatDateOutput(d: Date, withTime: boolean): string {
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  if (withTime) {
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
  return `${year}-${month}-${day}`;
}

export interface CalendarDayCell {
  date: Date;
  isCurrentMonth: boolean;
}

export function buildCalendarGrid(viewDate: Date): CalendarDayCell[] {
  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();

  // First day of current month (Monday = 0, Sunday = 6)
  const firstDay = new Date(year, month, 1);
  const startDayOfWeek = (firstDay.getDay() + 6) % 7;

  // Last day of current month
  const lastDay = new Date(year, month + 1, 0);
  const totalDays = lastDay.getDate();

  // Previous month tail days
  const prevMonthLastDay = new Date(year, month, 0).getDate();
  const days: CalendarDayCell[] = [];

  for (let i = startDayOfWeek - 1; i >= 0; i--) {
    days.push({
      date: new Date(year, month - 1, prevMonthLastDay - i),
      isCurrentMonth: false,
    });
  }

  // Current month days
  for (let i = 1; i <= totalDays; i++) {
    days.push({
      date: new Date(year, month, i),
      isCurrentMonth: true,
    });
  }

  // Next month start days to complete 42 cells (6 rows x 7 cols)
  const remaining = 42 - days.length;
  for (let i = 1; i <= remaining; i++) {
    days.push({
      date: new Date(year, month + 1, i),
      isCurrentMonth: false,
    });
  }

  return days;
}
